<template>
  <ion-page id="legacy-rep-builder-page">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
              @alert-result="alertResult"></AlertReplacement>

    <ion-content>

      <!-- <div v-show="showState == SHOW_REPERTOIRE_LIST">
        <RepSelector descriptionHeading='Select the Repertoire to Build/Edit' 
                    whoCalled=viewer @repertoire-manager-done="repertoireDone"/>
      </div> -->

      <div v-show="showTour">
        <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
      </div>

      <!-- Board -->
      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="displayFen" :validMoves="availableMoves" :orientation="orientation" 
                  :boardSize="boardSize" @board-move="boardMove" />
      </div>

      <!-- Move List -->
      <div id="the_movelist" :class="{ 'text-dark' : isDark, 'text-light' : !isDark }"
               :style="styleMoveList" :key="redrawTrigger">
        <MoveList :resultsData="availableMoves" :eighty="eighty" showCheckboxes=yes
                @movelist-click="movelistClick" @checkbox-click="checkboxClick" />
      </div>

      <!-- Tree -->
      <div id="the_tree" v-show="showTree != 'hide'" :style="styleRepTree" 
                  :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :key="redrawTrigger">
        <LegacyRepTree :calledFrom="showTree" :fenidPath="repTreeFenidPath" 
                      :showComments="showComments" :reloadRepertoire="reloadTrigger" 
                      @move-click="treeClick"/>
      </div>

      <!-- Move History -->
      <div id="the_movehistory" :class="{ 'text-dark' : isDark,'text-light' : !isDark }"
                  :style="styleMoveHistory">
        {{ initialRepertoireName }}
        <MoveHistory :moveHistoryStack="moveHistoryStack" :trigger="moveHistoryTrigger" />
      </div>
  
      <ActionSheet heading="Tree Display" :items="actionSheetButtons" 
                    :trigger="actionSheetTrigger"
                    @action-sheet-result="actionSheetResult">
      </ActionSheet> 
    </ion-content>
    <Toolbar id="the_toolbar" :ignoreClicks="showTour" :elements="toolbarElements"
                 :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

  import AlertReplacement from '@/components/AlertReplacement.vue'
  import { t } from '@/composables/translateText.js'

  import ActionSheet from '@/components/ActionSheet.vue'
  import ModalLegacyRepSelector from '@/components/ModalLegacyRepSelector.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { Chess } from '@/ts/chess.ts'
  import { buildPieceLocationStrings, getPieceSetName, columnToNumber } from 
                    '@/composables/blindfoldSupport.js'

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import CMChessboard from '@/components/CMChessboard.vue'
  import MoveList from '@/components/MoveList.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import MoveHistory from '@/components/MoveHistory.vue'

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'

  import { onMounted, onBeforeMount } from 'vue'
  import { ref, watch } from 'vue'
  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect , isScreenPortraitOrientation} from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import Tour from '@/components/Tour.vue'
  import LegacyRepTree from '@/components/LegacyRepTree.vue'

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  const showTour = ref((tourOption == "show"))
  
  const showComments = ref(true)

  var ratingFilter = "all"

  const ACTION_NO_TREE = 10
  const ACTION_STATIC_TREE = 11
  const ACTION_DYNAMIC_TREE = 12
  const ACTION_BIDIRECTIONAL_TREE = 13
  const ACTION_COMMENT_TREE = 14

  const actionSheetTrigger = ref(0)
  const actionSheetButtons = [
        { text: t("Hide"), data: { index : ACTION_NO_TREE } },
        { text: t("Display"), data: { index : ACTION_STATIC_TREE } },
        { text: t("Follow Along"), data: { index : ACTION_DYNAMIC_TREE } },
        { text: t("Bidirectional"), data: { index : ACTION_BIDIRECTIONAL_TREE } },
        { text: t('Cancel'), role: 'cancel',data: { index : -1}},
    ];

  const TOOLBAR_BACK = 0
  const TOOLBAR_REWIND = 1
  const TOOLBAR_TREE = 2
  const TOOLBAR_RATING = 3
  const TOOLBAR_REPERTOIRE = 4
  const TOOLBAR_COMMENT = 5
  const TOOLBAR_COPY = 6

  const TOOLBAR_RATING_BOTTOM = 20
  const TOOLBAR_RATING_MIDDLE = 21
  const TOOLBAR_RATING_TOP = 22
  const TOOLBAR_RATING_ALL = 23

  const TOOLBAR_RATING_BASE = 20
  const ratingStrings = ["bottom","middle","top","all"]
  var ratingFilter = "all"

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 * 2 + 4

  const emit = defineEmits(['boardMove'])

  const optionDisplayArray = [
     { index : 0, name : t("below") + " 1400", id : "bottom" , radio : "bottom" },
     { index : 0, name : "1400-1700", id : "middle" , radio : "middle" },
     { index : 0, name : t("above") + " 1700", id : "top" , radio : "top" },
     { index : 0, name : t("All"), id : "all" , radio : "all" }
      ]
  var optionDisplaySelected = ratingFilter

  const toolbarElements = ref([
    { index : TOOLBAR_BACK, label : "<" , disabled : true, collapse:false},
    { index : TOOLBAR_REWIND, label : "<<" , disabled : true, collapse:false},
    { index : TOOLBAR_TREE, label : t("Tree") ,disabled : false, collapse:false,hasAction:true},
    { index : TOOLBAR_RATING, label : t("Rating Filter") , disabled : false },
    { index : TOOLBAR_REPERTOIRE, label : t("Repertoire") ,disabled : false, collapse:true},
    { index : TOOLBAR_COPY, label : t("Copy") , disabled : false, collapse:false},
    { index : TOOLBAR_COMMENT, label : t("Comment") ,disabled : false, collapse:true},
  ])

  // NOTE: The user's repertoire trees all use 8 Byte FENID values.
  //       The server php code will find the 4 byte that goes with it

  var fenid = "1"

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  //console.log("**** explorer initial screensize", windowSizeRef.value)
  const boardSize = ref(100)

  const displayFen = ref(INITIAL_FEN)
  const eighty = ref(-2)

  var repertoireName = ""
  const initialRepertoireName = ref("Retrieving the Repertoire Information")

  var playingWhite = 1
  var blankAppendTrigger = " "
  var orientation = ref("white")

  const availableMoves = ref([])
  const moveHistoryStack = ref([])
  const moveHistoryTrigger = ref(0)
  const moveHistoryString = ref("")
  const toolbarTrigger = ref(0)

  const alertInfo = ref({})
  const alertTrigger = ref(0)

  const redrawTrigger = ref(0)
  const showTree = ref("hide")
  const repTreeFenidPath = ref("")
  const reloadTrigger = ref(0)

  // fill out the movelist with any moves that aren't in the tree
  const fensInTree = new Map();
  var chess = new Chess()

  // tour stuff
  const tourInfo = ref({
    id : "repertoire_builder",
    video : "https://www.chessvis.com/videos/repertoires_on_web.mp4",
    elements : [
      { id: "", title: t("Repertoire Builder"), text : t("With Chessvis, building a repertoire is as easy as making moves.<br><br>Note: the video is for the entire set of repertoire routines.")},
      { id: "the_movelist", title: t("The Move List"), text : t("All of the possible moves are listed.<br><br>Moves that have been played with any regularity are in the 'tree' and will show the game count and white win/loss percentages.")},
      { id: "the_movelist", title: t("The Game Universe"), text : t("The Lichess 'rapid' games were used to build the tree.<br><br>Note: the tree is still being filled out. It has 200M games now and will have 600M in a couple of months. After that about 16M games will be added every month.")},
      { id: "the_movelist", title: t("The Move List"), text : t("The move choices are sorted in order of popularity. The moves above the 'blue' line make up 80% of the games. (This helps you identify the moves that matter.)<br><br>The stockfish engine score is shown at the right")},
      { id: "the_movelist", title: t("More about the Move List"), text : t("Moves that aren't in the tree are listed last.<br><br>They don't have the win/loss percentages.")},
      { id: "the_movelist", title: t("Building the Repertoire"), text : t("As you make moves on the board or by selecting them on the move list they are added to the repertoire.<br><br>Toggling the checkboxes will add and remove moves from the repertoire.")},
      { id: "the_toolbar", title: t("Tree - Toolbar"), text : t("Chessvis can also show display the move tree while you're building the repertoire.<br><br>There are 3 levels of tree display.")},
      { id: "the_toolbar", title: t("Tree Display Levels - Toolbar"), text : t("<b>Display</b> - Static Tree<br><br><b>Follow Along</b> - the tree will be updated as you add moves.<br><br><b>Bidirectional</b> - selecting moves on the tree will cause the move list to jump to that location.")},
      { id: "the_toolbar", title: t("Rating Filter - Toolbar"), text : t("Different levels of players make different moves. It's important to filter the move tree to the bracket that you play in.")},
      { id: "the_toolbar", title: t("Repertoire - Toolbar"), text : t("This will bring up the list of repertoires so you can select a different one.")},
      { id: "the_toolbar", title: t("Comment - Toolbar"), text : t("Add and/or edit a comment associated with the board.<br><br><i>The 'tree' toolbar item can also toggle showing comments within the tree")},
    ]
  })

  const styleMoveList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleRepTree = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em"
  })

  
  function afterStartupCallbackRoutine(stuffChanged) {
    if (connectionStore.getIsSubscriber != 1) {
      return
    }
    updateWidthHeights()
    getInitialUserInfo()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  onBeforeMount(() => {
    //console.log("repertoire builder mounted")
    getMoves()

  })

  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** Explorer -- window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** Explorer new window size",windowSizeRef.value)
      updateWidthHeights()
      menuTrigger.value++
    })

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleMoveList.value.height = boundaries['moveList'].height + "px"
    styleMoveList.value.width = boundaries['moveList'].width + "px"
    styleMoveList.value.top = boundaries['moveList'].top + "px"
    styleMoveList.value.left = boundaries['moveList'].left + "px"

    styleRepTree.value.height = boundaries['repTree'].height + "px"
    styleRepTree.value.width = boundaries['repTree'].width + "px"
    styleRepTree.value.top = boundaries['repTree'].top + "px"
    styleRepTree.value.left = boundaries['repTree'].left + "px"

    styleMoveHistory.value.height = boundaries['history'].height + "px"
    styleMoveHistory.value.width = boundaries['history'].width + "px"
    styleMoveHistory.value.top = boundaries['history'].top + "px"
    styleMoveHistory.value.left = boundaries['history'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {
    // reserve space for move history and win/loss
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height/2,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const historyPositionTop = boardPositionTop + boardHeight
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = MOVEHISTORY_HEIGHT
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const availableHeightForRest = availableSpace.height - historyPositionTop - historyHeight
    const moveListHeight = (showTree.value == "hide") ? availableHeightForRest : (availableHeightForRest) / 2
    const repTreeHeight = (showTree.value == "hide") ? 0 : (availableHeightForRest) / 2

    const moveListPositionTop = historyPositionTop + historyHeight
    const moveListPositionLeft = availableSpace.leftRightIndent
    const moveListWidth = historyWidth

    const repTreePositionTop = moveListPositionTop + moveListHeight
    const repTreePositionLeft = availableSpace.leftRightIndent
    const repTreeWidth = historyWidth

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop+ availableSpace.topIndent
      },
      repTree : {
        width : repTreeWidth,
        height : repTreeHeight,
        left : repTreePositionLeft + availableSpace.leftIndent,
        top : repTreePositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

   // reserve space for win/loss & move history
   const availableSpaceForBoard = { width : availableSpace.width - 200,
                height : availableSpace.height - MOVEHISTORY_HEIGHT,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const moveListHeight = (showTree.value == "hide") ? availableSpace.height - MOVEHISTORY_HEIGHT : 
                                  (availableSpace.height - MOVEHISTORY_HEIGHT) / 2
    const repTreeHeight = (showTree.value == "hide") ? 0 : 
                                  (availableSpace.height - MOVEHISTORY_HEIGHT) / 2

    const moveListPositionTop = 0
    const moveListPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const moveListWidth = availableSpace.width - moveListPositionLeft

    const repTreePositionTop = moveListPositionTop + moveListHeight
    const repTreePositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const repTreeWidth = availableSpace.width - moveListPositionLeft

    const historyPositionTop = availableSpace.height  - MOVEHISTORY_HEIGHT
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = MOVEHISTORY_HEIGHT
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop+ availableSpace.topIndent
      },
      repTree : {
        width : repTreeWidth,
        height : repTreeHeight,
        left : repTreePositionLeft + availableSpace.leftIndent,
        top : repTreePositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function toolbarRewind() {
    incrementAppendTrigger()      
    displayFen.value = INITIAL_FEN + blankAppendTrigger
    fenid = "1"
    moveHistoryStack.value = []
    moveHistoryTrigger.value++

    buildRepTreeFenidPath()
    getMoves()
  }

  // Repertoire Selector Modal
  const repertoireSelectorModal = async () => {
    const modal = await modalController.create({
      component: ModalLegacyRepSelector,
      componentProps: {
        descriptionHeading : t('Select the Repertoire to build') ,
        whoCalled : "viewer"
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      if (data.changed)
        repertoireDone(data.changed)
    }
  };

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : t("Rating Filter")      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == optionDisplaySelected)
        return

      //console.log("CONFIRM in play collection",data)

      ratingFilter = data.selected
      updateRating(ratingFilter)

   }
  };
  // END Generic Options List

  function actionSheetResult(action,index) {
    var oldShow = ""

    if (action != "yes")
      return
    switch (index) {
      case ACTION_NO_TREE :
        showTree.value = "hide"
        updateWidthHeights()
        redrawTrigger.value++
        break;
      case ACTION_STATIC_TREE :
        oldShow = showTree.value
        showTree.value = "static"
        if (oldShow == "hide") {
          updateWidthHeights()
          redrawTrigger.value++
        }
        break;
      case ACTION_DYNAMIC_TREE :
        oldShow = showTree.value
        showTree.value = "dynamic"
        if (oldShow == "hide") {
          updateWidthHeights()
          redrawTrigger.value++
        }
        break;
      case ACTION_BIDIRECTIONAL_TREE :
        oldShow = showTree.value
        showTree.value = "bidirectional"
        if (oldShow == "hide") {
          updateWidthHeights()
          redrawTrigger.value++
        }
        break;
    }
  }

  function alertResult(response,task,info) {
    //console.log("Alert Result",response,task,fen.value)

    if (response == "no")
      return

    if (response == "fen") {
      const copyFen = displayFen.value.trim()
      var fenPieces = copyFen.split(" ")
      fenPieces[5] = 1
      const fenFixed = fenPieces.join(" ")
      navigator.clipboard.writeText(fenFixed);
    }
    else {
      grabPGN()
    }
  }

  function toolbarClick(index) {
    var oldShow = ""

    // trap that the button should be disabled but the screen hasn't caught up
    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
      return

    switch (index) {
      case TOOLBAR_COPY :
        alertInfo.value = { header : t("Copy to Clipboard") + "?" , 
                message : t("'FEN' of current board OR entire 'PGN'?"), type : "fenpgn", task : "fenpgn"  }
        alertTrigger.value++
        break
      case TOOLBAR_TREE :
        actionSheetTrigger.value++
        break
      case TOOLBAR_COMMENT : 
        if (moveHistoryStack.value.length == 0)
          break
        const lastMove = moveHistoryStack.value[moveHistoryStack.value.length -1]
        //console.log("LAST MOVE ON STACK",lastMove.fenid,lastMove.san,lastMove.comment)
        const comment = prompt(t("Comment for") + ": " + lastMove.san,lastMove.comment)
        if (comment == null)
          break
        moveHistoryStack.value[moveHistoryStack.value.length -1].comment = comment
        moveHistoryTrigger.value++
        setComment(lastMove.fenid,comment)
        break
      case TOOLBAR_BACK :
        if (moveHistoryStack.value.length <= 1) {
          toolbarRewind()
        }
        else {
          moveHistoryStack.value.pop()
          moveHistoryTrigger.value++
          displayFen.value = moveHistoryStack.value[moveHistoryStack.value.length - 1].fen
          fenid = moveHistoryStack.value[moveHistoryStack.value.length - 1].fenid

          buildRepTreeFenidPath()

          //console.log("**** back -> ",fenid,fen.value)
          getMoves()
        }
        break;
      case TOOLBAR_REWIND :  
        toolbarRewind()
        break;
      case TOOLBAR_REPERTOIRE :
        repertoireSelectorModal()
        break;
      case TOOLBAR_RATING :
        optionDisplaySelected = ratingFilter
        openGenericSingleListModal()
        break
    }
  }

  function buildRepTreeFenidPath() {
    if (showTree.value != "dynamic" && showTree.value != "bidirectional")
      return;

    var fenidArray = []

    for (var i=0; i < moveHistoryStack.value.length; i++)
      fenidArray.push(moveHistoryStack.value[i].fenid)
    repTreeFenidPath.value = fenidArray.join(",")

    //console.log("reptree path  ",repTreeFenidPath.value)
  }

  function checkboxClick(item) {
    //console.log("checkbox in repbuilder",item)

    const moveMade = availableMoves.value[item.index]

    setMoveFlag(moveMade.fen,moveMade.fenid,moveMade.san,moveMade.comment,item.flag,false)
  }

  function getNextMove(moveFen,moveFenid,moveSan,moveComment) {
    displayFen.value = moveFen
    fenid = moveFenid
    const san = moveSan
    
    const oneMove = {fen : moveFen, fenid: moveFenid,san : moveSan, comment : moveComment }
    moveHistoryStack.value.push(oneMove)
    moveHistoryTrigger.value++
    
    buildRepTreeFenidPath()

    getMoves()
  }

  function movelistClick(arrayIndex) {

    const moveMade = availableMoves.value[arrayIndex]

    // if clicked on move not in repertoire, add it and wait for response to update
    if (moveMade.repflagged == false)
      setMoveFlag(moveMade.fen,moveMade.fenid,moveMade.san,moveMade.comment,true,true)
    else
      getNextMove(moveMade.fen,moveMade.fenid,moveMade.san,moveMade.comment)

  }

  function treeClick(treeFen,generatedMoveHistoryStack) {
    //console.log("***** in tree Click",generatedMoveHistoryStack)
    if (generatedMoveHistoryStack == null)
      return
    initialRepertoireName.value = ""
    moveHistoryStack.value = generatedMoveHistoryStack
    moveHistoryTrigger.value++

    //console.log("***** in tree Click move history stack",moveHistoryStack.value)
    incrementAppendTrigger()
    if (moveHistoryStack.value.length > 0) {
      const oneHistoryMove = moveHistoryStack.value[moveHistoryStack.value.length - 1]
      //console.log("one hstory move ",oneHistoryMove)
      //console.log("one fen and fenid",oneHistoryMove.fen, oneHistoryMove.fenid)
      //console.log("current fen value",displayFen.value)
      //console.log("current fen",displayFen)
      fenid = oneHistoryMove.fenid
      displayFen.value = oneHistoryMove.fen 
      //console.log("Fen after tree click",displayFen.value)

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,false)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,false)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COMMENT,false)
      toolbarTrigger.value++

    }
    else {
      fenid = 1
      displayFen.value = INITIAL_FEN

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COMMENT,true)

      toolbarTrigger.value++

    }
    displayFen.value += blankAppendTrigger
    
    getMoves()
  }

  function tourDone() {
    showTour.value = false
  }

  function repertoireDone(didChange) {
    if (didChange) {
      toolbarRewind()
      reloadTrigger.value++;
      redrawTrigger.value++;
    }
  }

  function boardMove(arrayIndex,from,to) {
    initialRepertoireName.value = ""
    movelistClick(arrayIndex)
  }
  
  // add any moves that aren't in the move tree at the bottom of the list
  function addMovesNotInTree() {
    const FenForChessJS = displayFen.value.trim()
    //console.log("******** IN ADD MOVES ",FenForChessJS)
    chess.load(FenForChessJS)
    //console.log("******* AFTER LOAD")
    const moves = chess.moves({ verbose: true })

    //console.log("MOVES",moves)
    
    for (var i=0; i < moves.length; i++) {
      const oneChessMove = moves[i]

      // see if the board is already in the map
      const fenParts = oneChessMove.after.split(" ")
      if (fensInTree.has(fenParts[0]))
        continue

      // ignore any promotions other than queen
      if (oneChessMove.hasOwnProperty('promotion') && oneChessMove.promotion != 'q')
        continue;

      // this is a legal move that isn't in the tree. add it
      var tmp = oneChessMove.from.split("")
      var colNumber = columnToNumber(tmp[0])
      const fromSquareNumber = (8 - tmp[1]) * 8 + colNumber

      tmp = oneChessMove.to.split("")
      colNumber = columnToNumber(tmp[0])
      const toSquareNumber = (8 - tmp[1]) * 8 + colNumber

      const toArray = oneChessMove.to.split("")
      const fromArray = oneChessMove.from.split("")

      const oneMove = { index: availableMoves.value.length, fenid: 0, 
                          fen : oneChessMove.after,
                          from : fromSquareNumber,
                          to : toSquareNumber,
                          san : oneChessMove.san,
                          white : "0", black : "0", draw : "0",
                          castle : "",
                          check : "",
                          passant : "",
                          promotion : "",
                          comment : "",
                          showItalic : true,
                          repflagged : false
                      }
      //console.log("**** ADD ",oneMove)
      availableMoves.value.push(oneMove)
    }
  }

  function processJsonResponse (json) {
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    const isFirstMove = (moveHistoryStack.value.length == 0)

    if (isFirstMove) {
        repertoireName = json['repname']
        if (repertoireName == "") {
          initialRepertoireName.value = t('No Repertoire Selected')
          return
        }
        initialRepertoireName.value = t('Using Repertoire') + ": " + repertoireName
        playingWhite = parseInt(json['playingwhite'])
        orientation.value = (playingWhite == 1) ? "white" : "black"
        incrementAppendTrigger()
        displayFen.value = INITIAL_FEN + blankAppendTrigger 
    }
    else {
      initialRepertoireName.value = ""
    }
    //console.log("*** process Fens ***")
    //console.log(json)
    const whiteString = json['white']
    const blackString = json['black']
    const whites = whiteString.split("\t")
    const blacks = blackString.split("\t")
    const sans = json['san'].split("\t")
    const totals = json['total'].split("\t")
    const scores = json['score'].split("\t")
    const fens = json['fen'].split("\t")
    const fenids = json['fenid'].split("\t")
    const froms = json['from'].split("\t")
    const tos = json['to'].split("\t")
    const repFlags = json['rep'].split("\t")
    const sources = json['source'].split("\t")
    const comments = json['comment'].split("\t")
    
    eighty.value = json['eighty']
    const count = json['count']
  

    // when the move is part of the repertoire, show a checkbox (2) when player's move
    //      checkmark (1) when opponent

    const whiteToMove = 1 - (moveHistoryStack.value.length % 2)
    const showCheckboxes = (playingWhite == whiteToMove) ? "player" : "opponent"
    //console.log("white to move ",playingWhite,whiteToMove,showCheckboxes)

    fensInTree.clear()

    for (var i=0; i < count; i++) {
      // add fen to the map so when looking for unaccounted for moves, we'll be able to do a lookup
      // only concern ourselves with the board part
      const fenParts = fens[i].split(" ")
      fensInTree.set(fenParts[0],"")  

      const showItalic = (sources[i] != 'filtered')      // anything not 'filtered' gets italics on movelist

      const oneMove = { index: i, 
                        fenid: fenids[i], 
                        white : whites[i], 
                        black : blacks[i], 
                        draw : "0", 
                        from : froms[i], 
                        to: tos[i],
                        san : sans[i], 
                        total : totals[i], 
                        score : scores[i], 
                        fen : fens[i],
                        repflagged : (repFlags[i] == 1),
                        showItalic : showItalic,
                        comment : comments[i]
                      }

      availableMoves.value.push(oneMove)
    }

    //console.log(fensInTree)
    //console.log("availableMoves ",availableMoves.value)

    addMovesNotInTree()

    // there will always be moves since we're adding ones not in the tree
    if (eighty.value <= 0)
      eighty.value = 400

    // update the toolbar
    const ply = moveHistoryStack.value.length
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,(ply >= 1) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,(ply >= 1) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COMMENT,(ply >= 1) ? false : true)

    toolbarTrigger.value++
  }
  
  function getMoves() {

    // checkboxes is basically - "is this the player's move"
    const whiteToMove = 1 - (moveHistoryStack.value.length % 2)
    const checkboxes = (playingWhite == whiteToMove) ? 1 : 0

    var formData = {
      fenid : fenid,
      p : moveHistoryStack.value.length,
      white : whiteToMove,
      checkboxes : checkboxes
    }

    // zap waiting for next move values
    availableMoves.value = []

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COMMENT,true)

    toolbarTrigger.value++

    eighty.value = -2
    //console.log("before getweb2_repertoire_moves.php post -> ",formData)

    useGetData("getweb2_repertoire_moves.php", formData, processJsonResponse)
  }

  function processSetFlagJsonResponse (json) {
    //console.log(" in set flag callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    const moveFen = json['to_fen']
    const moveFenid = json['to_fenid']
    const moveSan = json['to_san']
    const moveComment = json['to_comment']
    const getNextMoveFlag = json['get_next_move_flag']

    // if clicked on just the checkbox, don't advance to next move
    if (getNextMoveFlag == 1)
      getNextMove(moveFen,moveFenid,moveSan,moveComment)

    // The repertoire has been updated on the server
    // If the tree is displayed, it should be asked to reload
    if (showTree.value != "hide")
      reloadTrigger.value++
  }

  function setMoveFlag(to_fen,to_fenid,to_san,to_comment,flagValue,advanceToNextMove) {

    const from_fenid = (moveHistoryStack.value.length == 0) ? 
                1 : moveHistoryStack.value[moveHistoryStack.value.length-1].fenid
   
    const is_on = (flagValue) ? 1 : 0

    var formData = {
      to_fenid : to_fenid,
      to_fen : to_fen,
      to_san : to_san,
      to_comment : to_comment,
      from_fenid : from_fenid,
      get_next_move_flag : (advanceToNextMove) ? 1 : 0,
      is_on : is_on
    }

    //console.log("Update move flag",formData)

    useGetData("setweb2_repertoire_flag.php", formData, processSetFlagJsonResponse)
  }

  function processSetCommentJsonResponse (json) {
    //console.log(" in set flag callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
  }

  function setComment(fenid,comment) {

    var formData = {
      fenid : fenid,
      comment : comment
    }

    //console.log("Update move flag",formData)

    useGetData("set2_comment.php", formData, processSetCommentJsonResponse)
  }

  function processInitialJsonResponse (json) {
    //console.log(" in initial json callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    ratingFilter = json['rating_filter']
    /*
    var id = 0
    switch (ratingFilter) {
      case "bottom" :
        id = TOOLBAR_RATING_BOTTOM
        break
      case "middle" :
        id = TOOLBAR_RATING_MIDDLE 
        break
      case "top" : 
        id = TOOLBAR_RATING_TOP 
        break
      default :
        ratingFilter = "all"
        id = TOOLBAR_RATING_ALL
        break
    }
    toolbarElements.value[TOOLBAR_RATING_FILTER].submenu[id - TOOLBAR_RATING_BASE].checked = true
    toolbarTrigger.value++
    */
    getMoves()

  }

  function getInitialUserInfo() {
    var formData = {}
    useGetData("getweb_user_explorer_tree_info.php", formData, processInitialJsonResponse)
  }

  function processRatingUpdateJsonResponse(json) {
    //console.log(" in set rating callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    // get the new counts based on the rating change
    getMoves()
  }

  function updateRating(newRating) {
    var formData = {
      rating : newRating
    }
    //console.log("before post -> ",formData)

    useGetData("setweb_rating_filter.php", formData, processRatingUpdateJsonResponse)
  }

  function processgrabPGNJsonResponse (json) {
    //console.log(" in PGN JSON callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    const pgn = json['pgn']
    navigator.clipboard.writeText(pgn)
  }

  function grabPGN() {

    const timeNow = Math.floor(Date.now() / 1000)

    const formData = {
      time : timeNow,
    }

    //console.log("before post  -> ",formData)

    useGetData("getweb9_legacy_repertoire_pgn.php", formData, processgrabPGNJsonResponse)
  }

</script>

<style>

#explorer-container {
  position : relative;
}

</style>
